"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconRearrange = props => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  viewBox: "0 0 18 20",
  ...props,
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M0,15 L18,15 L18,13 L0,13 L0,15 Z M0,11 L18,11 L18,9 L0,9 L0,11 Z M0,5 L0,7 L18,7 L18,5 L0,5 Z M6,17 L9,20 L12,17 L6,17 Z M12,3 L9,0 L6,3 L12,3 Z",
      id: "path-1"
    })
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(-463.000000, -827.000000)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        transform: "translate(463.000000, 827.000000)",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("mask", {
          id: "mask-2",
          fill: "white",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
            xlinkHref: "#path-1"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
          fill: props.style.fill || '#000000',
          fillRule: "nonzero",
          xlinkHref: "#path-1"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          mask: "url(#mask-2)",
          fill: props.style.fill || '#000000',
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(-3.000000, -2.000000)",
            id: "Rectangle",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
              x: "0",
              y: "0",
              width: "24",
              height: "24"
            })
          })
        })]
      })
    })
  })]
});
var _default = exports.default = (0, _withIcon.default)('IconRearrange')(IconRearrange);